package kpt.core.base.ui

import kotlin.String

internal object BuildKonfig {
  public val APP_DISPLAY_NAME: String = "Money Toolkit"
}
